import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { ReduxState, VehicleAndDriver } from 'types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import * as modalWindowActions from 'root/modal/modalWindowActions';
import * as vehiclesActions from 'features/vehicles/vehiclesActions';
import { ModalEnum } from 'myParkdUtils/enums';
import { LicensePlate } from './LocalisedLicensePlate';


export const LicensePlateRenderer = (props: Props) => {

    const vehicleAndDriver = props.vehicleAndDriver;
    const llp = vehicleAndDriver.vehicle.localizedLicensePlate;

    const deleteVehicle = () => {
        props.updateModal(ModalEnum.DELETE_VEHICLE, vehicleAndDriver.vehicle);
    }

    return (
        <>
            <FontAwesomeIcon
                icon={faCircleXmark}
                size='lg'
                className='icon-circle-x'
                onClick={deleteVehicle}
                data-testid='btn-delete-vehicle'
            />

            <LicensePlate llp={llp} />
        </>
    );
}


type OwnProps = {
    vehicleAndDriver: VehicleAndDriver
};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = StateProps & DispatchProps & OwnProps;

function mapStateToProps(state: ReduxState) {
    return {
        token: state.auth?.token
    };
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
    return bindActionCreators({
        updateModal: modalWindowActions.updateModalWindow,
        removeDriverAfterUnclaim: vehiclesActions.removeDriverAfterUnclaim,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LicensePlateRenderer);